<template>
  <div>
    <div class="main" @click.capture="hide">
      <div class="nav">
        <img @click="$router.go(-1)" style="width: 24px;height: 22px;margin-right:5px;" src="../../assets/image/back.png" alt="">
        <p style="font-family: PingFang-SC-Regular;font-size: 18px;font-weight: normal;font-stretch: normal;letter-spacing: 0px;color: #000000;">参数设置</p>
      </div>
      <div class="scroll">
        <div class="cont">
          <!-- 本机设置 -->
          <div class="box1">
            <div class="title">
              <div class="dian"></div>
              <p>本机设置</p>
            </div>
            <div class="items">
              <div class="row">
                <div class="item">
                  <p>接口地址:</p>
                  <input v-model="datas.deviceSettingBean.serverAddress" type="text" placeholder="请输入地址">
                </div>
                <div class="item">
                  <p>本机ip地址:</p>
                  <input type="text" placeholder="请输入地址">
                </div>
                <div class="item">
                  <p>本机流量卡号:</p>
                  <input v-model="datas.deviceSettingBean.cardNumber" type="text" placeholder="请输入卡号">
                </div>
                <div class="item">
                  <p>本机通信地址:</p>
                  <input v-model="datas.deviceSettingBean.mailingAddress" type="text" placeholder="请输入地址">
                </div>
              </div>
              <div class="row">
                <div class="item">
                  <p>吊钩摄像头序列号:</p>
                  <input v-model="datas.deviceSettingBean.hookVisualization" type="text" placeholder="请输入序列号">
                </div>
                <div class="item item-xxx">
                  <p>数据请求频率:</p>
                  <input type="text" placeholder="请输入时间">
                </div>
                <div class="item">
                  <p>启动人脸识别:</p>
                  <button
                    :class="datas.deviceSettingBean.openFace?'btn2':'btn1'"
                    @click="openFace"
                    >{{datas.deviceSettingBean.openFace?'关闭':'开启'}}</button>
                </div>
                <div class="item">
                  <p>摄像头方向:</p>
                  <button 
                    :class="datas.deviceSettingBean.cameraType?'btn2':'btn1'"
                    @click="cameraType"
                    >{{datas.deviceSettingBean.cameraType?'关闭':'开启'}}</button>
                </div>
              </div>
              <div class="row">
                <div class="item">
                  <p>摄像头变倍:</p>
                  <input v-model="datas.deviceSettingBean.cameraZoom" type="text" placeholder="请输入">
                </div>
                <div class="item">
                  <p>电量预警:</p>
                  <input v-model="datas.deviceSettingBean.electricWarning" type="text" placeholder="请输入">
                </div>
                <div class="item">
                  <!-- <p>电量预警:</p>
                  <input v-model="datas.deviceSettingBean.electricWarning" type="text" placeholder="请输入"> -->
                </div>
                <div class="item">
                  <!-- <p>电量预警:</p>
                  <input v-model="datas.deviceSettingBean.electricWarning" type="text" placeholder="请输入"> -->
                </div>
              </div>
              <div class="row" style="justify-content: center;">
                <div class="btn-i" style="width: 100px;" @click="Reset1">
                  重置
                </div>
                <div style="width: 60px;"></div>
                <div class="blue" style="width: 100px;" @click="uploadDatas">
                  上传
                </div>
              </div>
            </div>
          </div>
          <div class="box">
            <!-- 高度设置 -->
          <div class="box2">
            <div class="title">
              <div class="dian"></div>
              <p>高度设置</p><p class="text">- 吊塔高度</p>
            </div>
            <div class="cont-i">
              <div class="row-i">
                <p>吊钩最高处传感器值：</p>
                <div class="row-i-r">
                  <input v-model="datas.heightSettingBean.heightSensorUp" type="text" placeholder="连接回应传感器">
                  <!-- <div class="blue">获取</div> -->
                  <div></div>
                </div>
              </div>
              <div class="row-i">
                <p>吊钩最高处离大臂距离：</p>
                <div class="row-i-r">
                  <input v-model="datas.heightSettingBean.heightInitialUp" type="text" placeholder="请输入数值">
                  <div class="unit">/m</div>
                </div>
                
              </div>
              <div class="row-i">
                <p>吊臂最低处传感器值：</p>
                <div class="row-i-r">
                  <input v-model="datas.heightSettingBean.heightSensorDown" type="text" placeholder="连接回应传感器">
                  <!-- <div class="blue">获取</div> -->
                  <div></div>
                </div>
              </div>
              <div class="row-i">
                <p>吊钩最低处离大臂距离：</p>
                <div class="row-i-r">
                  <input v-model="datas.heightSettingBean.heightInitialDown" type="text" placeholder="请输入数值">
                  <div class="unit">/m</div>
                </div>
              </div>
              <div class="row-i">
                <p>塔吊高度：</p>
                <div class="row-i-r">
                  <input v-model="datas.heightSettingBean.towerHeight" type="text" placeholder="请输入数值">
                  <div class="unit">/m</div>
                </div>
              </div>
              <div class="row-i">
                <p>高度预警值：</p>
                <div class="row-i-r">
                  <input v-model="datas.heightSettingBean.heightEarlyWarning" type="text" placeholder="请输入数值">
                  <div class="unit">/m</div>
                </div>
              </div>
              <div class="row-i">
                <p>高度报警值：</p>
                <div class="row-i-r">
                  <input v-model="datas.heightSettingBean.heightWarning" type="text" placeholder="请输入数值">
                  <div class="unit">/m</div>
                </div>
              </div>
              <div class="cont-i-b">
                <button class="btn-i" @click="Reset2">重置</button>
                <button class="blue" @click="uploadDatas">上传</button>
              </div>
            </div>
          </div>
          <!-- 幅度设置 -->
          <div class="box3">
            <div class="title">
              <div class="dian"></div>
              <p>幅度设置</p><p class="text">- 小车幅度</p>
            </div>
            <div class="cont-i">
              <div class="row-i">
                <p>小车最近处传感器值：</p>
                <div class="row-i-r">
                  <input v-model="datas.rangeSettingBean.rangeSensorNear" type="text" placeholder="连接回应传感器">
                  <!-- <div class="blue">获取</div> -->
                  <div></div>
                </div>
              </div>
              <div class="row-i">
                <p>小车最近处离驾驶舱距离：</p>
                <div class="row-i-r">
                  <input v-model="datas.rangeSettingBean.rangeNear" type="text" placeholder="请输入数值">
                  <div class="unit">/m</div>
                </div>
                
              </div>
              <div class="row-i">
                <p>小车最远处传感器值：</p>
                <div class="row-i-r">
                  <input v-model="datas.rangeSettingBean.rangeSensorFar" type="text" placeholder="连接回应传感器">
                  <!-- <div class="blue">获取</div> -->
                  <div></div>
                </div>
              </div>
              <div class="row-i">
                <p>小车最远处离驾驶舱距离：</p>
                <div class="row-i-r">
                  <input v-model="datas.rangeSettingBean.rangeFar" type="text" placeholder="请输入数值">
                  <div class="unit">/m</div>
                </div>
              </div>
              <div class="row-i">
                <p>塔吊臂长：</p>
                <div class="row-i-r">
                  <input v-model="datas.rangeSettingBean.towerArmLength" type="text" placeholder="请输入数值">
                  <div class="unit">/m</div>
                </div>
              </div>
              <div class="row-i">
                <p>幅度预警值：</p>
                <div class="row-i-r">
                  <input v-model="datas.rangeSettingBean.rangeEarlyWarning" type="text" placeholder="请输入数值">
                  <div class="unit">/m</div>
                </div>
              </div>
              <div class="row-i">
                <p>幅度报警值：</p>
                <div class="row-i-r">
                  <input v-model="datas.rangeSettingBean.rangeWarning" type="text" placeholder="请输入数值">
                  <div class="unit">/m</div>
                </div>
              </div>
              <div class="cont-i-b">
                <button class="btn-i" @click="Reset3">重置</button>
                <button class="blue" @click="uploadDatas">上传</button>
              </div>
            </div>
          </div>
          <!-- 回转设置 -->
          <div class="box4">
            <div class="title">
              <div class="dian"></div>
              <p>回转设置</p>
            </div>
            <div class="cont-i">
              <div class="row-i row-aa">
                <p>传感器实时数据：</p>
                <div class="row-i-r">
                  <input v-model="datas.rotationSettingBean.rotationSensorValue" type="text" placeholder="连接回应传感器">
                  <!-- <div class="blue">置为正北</div> -->
                  <div></div>
                </div>
              </div>
              <div class="row-i row-a">
                <p>回转碰撞预警值：</p>
                <div class="row-i-r">
                  <input v-model="datas.rotationSettingBean.rotationEarlyWarning" type="text" placeholder="请输入数值">
                  <div class="unit">/°</div>
                </div>
              </div>
              <div class="row-i row-a">
                <p>回转碰撞报警值：</p>
                <div class="row-i-r">
                  <input v-model="datas.rotationSettingBean.rotationWarning" type="text" placeholder="连接回应传感器">
                  <div class="unit">/°</div>
                </div>
              </div>
              <div class="cont-i-b">
                <button class="btn-i" @click="Reset4">重置</button>
                <button class="blue" @click="uploadDatas">上传</button>
              </div>
            </div>
          </div>
          <!-- 重量设置 -->
          <div class="box5">
            <div class="title">
              <div class="dian"></div>
              <p>重量设置</p>
            </div>
            <div class="cont-i">
              <div class="row-i row-c">
                <p>传感器空值：</p>
                <div class="row-i-r">
                  <input v-model="datas.weightSettingBean.weightNoLoadSensorValue" type="text" placeholder="连接回应传感器">
                  <!-- <div class="blue">获取</div> -->
                  <div></div>
                </div>
              </div>
              <div class="row-i row-c">
                <p>传感器标准砝码值：</p>
                <div class="row-i-r">
                  <input v-model="datas.weightSettingBean.weightSensorValue" type="text" placeholder="连接回应传感器">
                  <!-- <div class="blue">获取</div> -->
                  <div></div>
                </div>
                
              </div>
              <div class="row-i row-c">
                <p>吊载标准砝码：</p>
                <div class="row-i-r">
                  <input v-model="datas.weightSettingBean.weightValue" type="text" placeholder="请输入数值">
                  <div class="unit">/T</div>
                </div>
              </div>
              <div class="row-i row-c">
                <p>吊载额定重量：</p>
                <div class="row-i-r">
                  <input v-model="datas.weightSettingBean.weightRated" type="text" placeholder="请输入数值">
                  <div class="unit">/T</div>
                </div>
              </div>
              <div class="row-i row-c">
                <p>重量预警值：</p>
                <div class="row-i-r">
                  <input v-model="datas.weightSettingBean.weightEarlyWarning" type="text" placeholder="请输入数值">
                  <div class="unit">/T</div>
                </div>
              </div>
              <div class="row-i row-c">
                <p>重量报警值：</p>
                <div class="row-i-r">
                  <input v-model="datas.weightSettingBean.weightWarning" type="text" placeholder="请输入数值">
                  <div class="unit">/T</div>
                </div>
              </div>
              <div class="cont-i-b">
                <button class="btn-i" @click="Reset5">重置</button>
                <button class="blue" @click="uploadDatas">上传</button>
              </div>
            </div>
          </div>
          <!-- 风速设置 -->
          <div class="box6">
            <div class="title">
              <div class="dian"></div>
              <p>风速设置</p>
            </div>
            <div class="cont-i">
              <div class="row-i row-dd row-d">
                <p>风速预警值：</p>
                <div class="row-i-r">
                  <div class="menu">
                    <div class="menu-title" @click="show(1)"><p>{{datas.windSpeedSettingBean.windSpeedEarlyWarning!==''?datas.windSpeedSettingBean.windSpeedEarlyWarning:'请选择数据'}}</p><i></i></div>
                    <div class="menu-content" v-if="isShow.a">
                      <div class="m-c-t">安全风值：</div>
                      <div class="m-c-t-b"><p>风速</p><p>风级</p></div>
                      <div class="m-c-item" @click="fenji('0.0')"><p>0.2-2</p><p>0</p></div>
                      <div class="m-c-item" @click="fenji('1.0')"><p>0.3-1.5</p><p>1</p></div>
                      <div class="m-c-item" @click="fenji('2.0')"><p>1.6-3.3</p><p>2</p></div>
                      <div class="m-c-item" @click="fenji('3.0')"><p>3.4-5.4</p><p>3</p></div>
                      <div class="m-c-item" @click="fenji('4.0')"><p>5.5-7.9</p><p>4</p></div>
                      <div class="m-c-t">预警风值：</div>
                      <div class="m-c-t-b"><p>风速</p><p>风级</p></div>
                      <div class="m-c-item" @click="fenji('5.0')"><p>8.0-10.8</p><p>5</p></div>
                      <div class="m-c-item" @click="fenji('6.0')"><p>10.8-13.8</p><p>6</p></div>
                    </div>
                  </div>
                  <div class="unit">m/s</div>
                </div>
              </div>
              <div class="row-i row-d">
                <p>风速报警值：</p>
                <div class="row-i-r">
                  <div class="menu">
                    <div class="menu-title" @click="show(2)"><p>{{datas.windSpeedSettingBean.windSpeedWarning?datas.windSpeedSettingBean.windSpeedWarning:'请选择数据'}}</p><i></i></div>
                    <div class="menu-content menu-content-b " v-if="isShow.b">
                      <div class="m-c-t">危险风值：</div>
                      <div class="m-c-t-b"><p>风速</p><p>风级</p></div>
                      <div class="m-c-item" @click="fenji1('7.0')"><p>13.9-17.1</p><p>7</p></div>
                      <div class="m-c-item" @click="fenji1('8.0')"><p>17.2-20.7</p><p>8</p></div>
                      <div class="m-c-item" @click="fenji1('9.0')"><p>20.8-24.4</p><p>9</p></div>
                      <div class="m-c-item" @click="fenji1('10.0')"><p>24.5-28.4</p><p>10</p></div>
                      <div class="m-c-item" @click="fenji1('11.0')"><p>28.5-32.6</p><p>11</p></div>
                      <div class="m-c-item" @click="fenji1('12.0')"><p>32.7-36.9</p><p>12</p></div>
                    </div>
                  </div>
                  <div class="unit">m/s</div>
                </div>
              </div>
              <div class="cont-i-b">
                <button class="btn-i" @click="Reset6">重置</button>
                <button class="blue" @click="uploadDatas">上传</button>
              </div>
            </div>
          </div>
          <!-- 倾角设置 -->
          <div class="box7">
            <div class="title">
              <div class="dian"></div>
              <p>倾角设置</p>
            </div>
            <div class="cont-i">
              <div class="row-i row-aa">
                <p>传感器实时数据：</p>
                <div class="row-i-r">
                  <div
                    style="width: 188px;
                          height: 26px;
                          display: flex;
                          justify-content: space-between;
                          align-items: center;
                          font-size: 12px;
                          line-height: 26px;
                          text-align: start;
                          color: #858585;"
                    ><input class="jiaodu" v-model="datas.dipAngleSettingBean.dipAngleX" type="text">X
                      <input class="jiaodu" v-model="datas.dipAngleSettingBean.dipAngleY" type="text">Y
                    </div>
                  <!-- <div class="blue">置零</div> -->
                  <div></div>
                </div>
              </div>
              <div class="row-i row-a">
                <p>倾角预警值：</p>
                <div class="row-i-r">
                  <input v-model="datas.dipAngleSettingBean.dipAngleEarlyWarning" type="text" placeholder="请输入数值">
                  <div class="unit">/°</div>
                </div>
              </div>
              <div class="row-i row-a">
                <p>倾角报警值：</p>
                <div class="row-i-r">
                  <input v-model="datas.dipAngleSettingBean.dipAngleWarning" type="text" placeholder="请输入数值">
                  <div class="unit">/°</div>
                </div>
              </div>
              <div class="cont-i-b">
                <button class="btn-i" @click="Reset7">重置</button>
                <button class="blue" @click="uploadDatas">上传</button>
              </div>
            </div>
          </div>
          <!-- 防碰撞设置 -->
          <div class="box8">
            <div class="title">
              <div class="dian"></div>
              <p>防碰撞设置</p>
            </div>
            <div class="cont-i">
              <!-- <div class="row-i">
                <p>防碰撞开关</p>
                <div class="row-i-r">
                  <div></div>
                  <div class="blue">开启</div>
                </div>
              </div> -->
              <div class="row-i">
                <p>设备号</p>
                <div class="row-i-r">
                  <div class="text-i">坐标 (X/m)坐标 (Y/m)</div>
                  <div class="text-i" style="margin-right:14px">操作</div>
                </div>
              </div>
              <!-- 数据渲染 -->
              <div class="row-i" v-for="(item,index) in datas1.viewsBeanList" :key="index">
                <p>{{item.sn}}</p>
                <div class="row-i-r">
                  <div class="text-ii"><p style="width:50px;text-align:center;">{{item.x}}</p><p style="width:50px;text-align:center;margin-left:14px">{{item.y}}</p></div>
                  <div class="text-i btn-i" @click="delItem2(index)">删除</div>
                </div>
              </div>
              <div class="cont-i-b bb">
                <div class="blue" @click="isShow.dialogVisible = true">添加</div>
                <!-- <div class="blue btnn" @click="uploadDatas">同步至服务器</div> -->
              </div>
            </div>
          </div>
          <!-- 碰撞预警设置 -->
          <div class="box9">
            <div class="title">
              <div class="dian"></div>
              <p>碰撞预警设置</p>
            </div>
            <div class="cont-i">
              <div class="row-i">
                <p>设备号</p>
                <div class="row-i-r">
                  <div class="content-s">
                    <div class="item-s">开始角度</div>
                    <div class="item-s">结束角度</div>
                  </div>
                  <div class="text-i" style="margin-right:14px">操作</div>
                </div>
              </div>
              <div class="row-i" v-for="(item,index) in datas1.warningAngleBeans" :key="index">
                <p>{{item.deviceId}}</p>
                <div class="row-i-r">
                  <div class="content-s">
                    <div class="item-s text-i">{{item.warningAngleStart}}</div>
                    <div style="margin-right:31px" class="item-s text-i">{{item.warningAngleEnd}}</div>
                  </div>
                  <div class="text-i btn-i" style="margin-right:6px" @click="delItem1(index)">删除</div>
                </div>
              </div>
              
              <div class="cont-i-b bb">
                <div class="blue" @click="isShow.dialogVisible2 = true">添加</div>
                <!-- <div class="blue btnn" @click="uploadDatas">同步至服务器</div> -->
              </div>
            </div>
          </div>
          <!-- 力矩设置 -->
          <div class="box10">
            <div class="title">
              <div class="dian"></div>
              <p @click="uploadTowerSettings">力矩设置</p>
            </div>
            <div class="cont-i">
              <div class="row-i row-aaa">
                <p>最大起重矩：</p>
                <div class="row-i-r">
                  <input type="text" placeholder="请输入数值">
                  <div class="unit">/t*m</div>
                </div>
              </div>
              <div class="cont-i-b">
                <button class="btn-i">重置</button>
                <button class="blue" @click="uploadDatas">上传</button>
              </div>
            </div>
          </div>
          </div>
        </div>
        <!-- 弹出层 -->
        <el-dialog
          title="防碰撞设置"
          :visible.sync="isShow.dialogVisible"
          width="30%"
          :before-close="handleClose">
            <div class="cont-i">
              <div class="row-i row-aa">
                <p>设备号</p>
                <div class="row-i-r">
                  <input v-model="list2.sn" type="text" placeholder="请输入设备编码">
                  <div></div>
                </div>
              </div>
              <div class="row-i row-a">
                <p>坐标</p>
                <div class="row-i-r">
                  <input v-model="list2.x" type="text" placeholder="请输入数值">
                  <div class="unit">(X/m)</div>
                </div>
              </div>
              <div class="row-i row-a">
                <p>坐标</p>
                <div class="row-i-r">
                  <input v-model="list2.y" type="text" placeholder="请输入数值">
                  <div class="unit">(Y/m)</div>
                </div>
              </div>
            </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="isShow.dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="addlist2">确 定</el-button>
          </span>
        </el-dialog>
        <el-dialog
          title="碰撞回转预警设置"
          :visible.sync="isShow.dialogVisible2"
          width="30%"
          :before-close="handleClose2">
            <div class="cont-i">
              <div class="row-i row-aa">
                <p>设备号</p>
                <div class="row-i-r">
                  <input v-model="list.deviceId" type="text" placeholder="请输入设备编码">
                  <div></div>
                </div>
              </div>
              <div class="row-i row-a">
                <p>预警开始角度</p>
                <div class="row-i-r">
                  <input v-model="list.warningAngleStart" type="text" placeholder="请输入数值">
                  <div class="unit">/°</div>
                </div>
              </div>
              <div class="row-i row-a">
                <p>预警结束角度</p>
                <div class="row-i-r">
                  <input v-model="list.warningAngleEnd" type="text" placeholder="请输入数值">
                  <div class="unit">/°</div>
                </div>
              </div>
            </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="isShow.dialogVisible2 = false">取 消</el-button>
            <el-button type="primary"  @click="addlist">确 定</el-button>
          </span>
        </el-dialog>
        <el-dialog
        class="chongzhi"
          title="提示"
          :visible.sync="isShow.dialogVisible3"
          width="30%"
          :before-close="handleClose">
          <span>{{this.reset===11?'是否确定上传数据':this.reset===8?'是否删除该项数据':'是否重置该模块数据'}}</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="isShow.dialogVisible3 = false">取 消</el-button>
            <el-button type="primary" @click="Resetss">确 定</el-button>
          </span>
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { Loading } from 'element-ui'
import myHttp from '../../../src/untils/port'
  export default {
    data() {
      return {
        isShow: {
          a:false,
          b:false,
          dialogVisible: false,
          dialogVisible2:false,
          dialogVisible3:false
        },
        actives:{
          active1:false,
          active2:false
        },
        datas:{
          deviceSettingBean:{
              cameraType:false,
              cardNumber:'',
              hookVisualization:'',
              mailingAddress:'',
              openFace:false,
              serverAddress:'',
              cameraZoom:'',
              electricWarning:''
          },
          dipAngleSettingBean:{
              dipAngleEarlyWarning:'',
              dipAngleWarning:'',
              dipAngleX:'',
              dipAngleY:''
          },
          heightSettingBean:{
              heightCoefficientValue:'',
              heightEarlyWarning:'',
              heightInitialDown:'',
              heightInitialUp:'',
              heightSensorDown:'',
              heightSensorUp:'',
              heightWarning:'',
              towerHeight:''
          },
          rangeSettingBean:{
              rangeCoefficientValue:'',
              rangeEarlyWarning:'',
              rangeFar:'',
              rangeNear:'',
              rangeSensorFar:'',
              rangeSensorNear:'',
              rangeWarning:'',
              towerArmLength:''
          },
          rotationSettingBean:{
              rotationEarlyWarning:'',
              rotationSensorValue:'',
              rotationWarning:'',
          },
          weightSettingBean:{
              weightCoefficientValue:'',
              weightEarlyWarning:'',
              weightNoLoadSensorValue:'',
              weightRated:'',
              weightSensorValue:'',
              weightValue:'',
              weightWarning:''
          },
          windSpeedSettingBean:{
              windSpeedEarlyWarning:'',
              windSpeedWarning:''
          }
        },//基础信息
        datas1:{
          viewsBeanList:[
              // {
              //     dbId:0,
              //     sn:'',
              //     x:'',
              //     y:''
              // }
          ],
          warningAngleBeans:[
              // {
              //     dbId:0,
              //     deviceId:'',
              //     warningAngleEnd:'',
              //     warningAngleStart:''
              // }
          ]
        }, //防碰撞信息
        list:{
          deviceId:'',
          warningAngleEnd:'',
          warningAngleStart:''
        },
        list2:{
          sn:'',
          x:'',
          y:''
        },
        reset:0,
        upload:0,
        del1:0,
        del2:''
      }
    },
    mounted(){
      this.getBasic()
      this.getCollision()
      console.log(this.$route.query.id)
    },
    methods:{
      uploadDatas(){
        this.isShow.dialogVisible3=true
        this.reset = 11
      },
      openFace(){
        this.datas.deviceSettingBean.openFace=!this.datas.deviceSettingBean.openFace
        this.uploadTowerSettings()
        if(this.datas.deviceSettingBean.openFace){
          this.$message({
            message: '人脸识别已开启',
            type: 'success'
          })
        }else{
          this.$message({
            message: '人脸识别已关闭',
            type: 'warning'
          })
        }
      },
      cameraType(){
        this.datas.deviceSettingBean.cameraType=!this.datas.deviceSettingBean.cameraType
        this.uploadTowerSettings()
        if(this.datas.deviceSettingBean.cameraType){
          this.$message({
            message: '摄像头方向已开启',
            type: 'success'
          })
        }else{
          this.$message({
            message: '摄像头方向已关闭',
            type: 'warning'
          })
        }
      },
      Resetss(){
        if(this.reset===1){
          this.datas.deviceSettingBean.serverAddress=''
          this.datas.deviceSettingBean.cardNumber=''
          this.datas.deviceSettingBean.mailingAddress=''
          this.datas.deviceSettingBean.hookVisualization=''
          this.isShow.dialogVisible3 = false
          this.reset=0
        }else if(this.reset===2){
          this.datas.heightSettingBean.heightSensorUp=''
          this.datas.heightSettingBean.heightInitialUp=''
          this.datas.heightSettingBean.heightSensorDown=''
          this.datas.heightSettingBean.heightInitialDown=''
          this.datas.heightSettingBean.towerHeight=''
          this.datas.heightSettingBean.heightEarlyWarning=''
          this.datas.heightSettingBean.heightWarning=''
          this.isShow.dialogVisible3 = false
          this.reset=0
        }else if(this.reset===3){
          this.datas.rangeSettingBean.rangeSensorNear=''
        this.datas.rangeSettingBean.rangeNear=''
        this.datas.rangeSettingBean.rangeSensorFar=''
        this.datas.rangeSettingBean.rangeFar=''
        this.datas.rangeSettingBean.towerArmLength=''
        this.datas.rangeSettingBean.rangeEarlyWarning=''
        this.datas.rangeSettingBean.rangeWarning=''
        this.isShow.dialogVisible3 = false
          this.reset=0
        }else if(this.reset===4){
          this.datas.rotationSettingBean.rotationSensorValue=''
        this.datas.rotationSettingBean.rotationEarlyWarning=''
        this.datas.rotationSettingBean.rotationWarning=''
        this.isShow.dialogVisible3 = false
          this.reset=0
        }else if(this.reset===5){
          this.datas.weightSettingBean.weightNoLoadSensorValue=''
        this.datas.weightSettingBean.weightSensorValue=''
        this.datas.weightSettingBean.weightValue=''
        this.datas.weightSettingBean.weightRated=''
        this.datas.weightSettingBean.weightEarlyWarning=''
        this.datas.weightSettingBean.weightWarning=''
        this.isShow.dialogVisible3 = false
          this.reset=0
        }else if(this.reset===6){
          this.datas.windSpeedSettingBean.windSpeedEarlyWarning=''
        this.datas.windSpeedSettingBean.windSpeedWarning=''
        this.isShow.dialogVisible3 = false
          this.reset=0
        }else if(this.reset===7){
          this.datas.dipAngleSettingBean.dipAngleX=''
        this.datas.dipAngleSettingBean.dipAngleY=''
        this.datas.dipAngleSettingBean.dipAngleEarlyWarning=''
        this.datas.dipAngleSettingBean.dipAngleWarning=''
        this.isShow.dialogVisible3 = false
          this.reset=0
        }else if(this.reset===8){
          // 删除防碰撞设置信息
          this.datas1.viewsBeanList.splice(this.del1, 1)
          let data1 = JSON.stringify(this.datas1)
          let sj = this.sj()
          let _this = this
          myHttp.uploadCollisionSettings({
            "imei": `${_this.$route.query.id}`,
            "settings": `${data1}`,
            "setDate": `${sj}`
          }).then(res=>{
            if(res.data.code===200){
                _this.$message({
                message: '删除成功',
                type: 'success'
            })
            }
            })
          _this.isShow.dialogVisible3 = false
          _this.reset=0
        }else if(this.reset===9){
          // 删除碰撞预警设置信息
          this.datas1.warningAngleBeans.splice(this.del1, 1)
          let data1 = JSON.stringify(this.datas1)
          let sj = this.sj()
          let _this = this
          myHttp.uploadCollisionSettings({
            "imei": `${_this.$route.query.id}`,
            "settings": `${data1}`,
            "setDate": `${sj}`
          }).then(res=>{
            if(res.data.code===200){
                _this.$message({
                message: '删除成功',
                type: 'success'
            })
            }
            })
          _this.isShow.dialogVisible3 = false
          _this.reset=0
        }else if(this.reset===11){
          // this.uploadTowerSettings()
          // 同步至服务器防碰撞设置
        let data1 = JSON.stringify(this.datas)
        let sj = this.sj()
        let _this = this
        myHttp.uploadTowerSettings({
          "imei": `${_this.$route.query.id}`,
          "settings": `${data1}`,
          "setDate": `${sj}`
        }).then(res=>{
          if(res.data.code===200){
            _this.$message({
            message: '上传成功',
            type: 'success'
        })
          }
        })
        this.isShow.dialogVisible3 = false
        }
      },
      Reset1(){
        this.isShow.dialogVisible3 = true
        this.reset=1
      },
      Reset2(){
        this.isShow.dialogVisible3 = true
        this.reset=2
      },
      Reset3(){
        this.isShow.dialogVisible3 = true
        this.reset=3
      },
      Reset4(){
        this.isShow.dialogVisible3 = true
        this.reset=4
      },
      Reset5(){
        this.isShow.dialogVisible3 = true
        this.reset=5
      },
      Reset6(){
        this.isShow.dialogVisible3 = true
        this.reset=6
      },
      Reset7(){
        this.isShow.dialogVisible3 = true
        this.reset=7
      },
      addlist(){
        this.isShow.dialogVisible2 = false
        let item = {}
        item = {...this.list}
        console.log(this.datas1.warningAngleBeans)
        if(!this.datas1.warningAngleBeans){
          this.datas1.warningAngleBeans=[]
        }
        this.datas1.warningAngleBeans.push(item)
        this.list = {}
         // 同步至服务器防碰撞设置
        let data1 = JSON.stringify(this.datas1)
        let sj = this.sj()
        let _this = this
        myHttp.uploadCollisionSettings({
          "imei": `${_this.$route.query.id}`,
          "settings": `${data1}`,
          "setDate": `${sj}`
        }).then(res=>{
          if(res.data.code===200){
            _this.$message({
            message: '添加成功',
            type: 'success'
        })
          }
        })
      },
      addlist2(){
        this.isShow.dialogVisible = false
        let item = {}
        item = {...this.list2}
        this.datas1.viewsBeanList.push(item)
        this.list2 = {}
         // 同步至服务器防碰撞设置
        let data1 = JSON.stringify(this.datas1)
        let sj = this.sj()
        let _this = this
        myHttp.uploadCollisionSettings({
          "imei": `${_this.$route.query.id}`,
          "settings": `${data1}`,
          "setDate": `${sj}`
        }).then(res=>{
          if(res.data.code===200){
            _this.$message({
            message: '添加成功',
            type: 'success'
        })
          }
        })
      },
      delItem1(index){
        this.del1 = index
        this.isShow.dialogVisible3 = true
        this.reset=9
      },
      delItem2(index){
        this.del1 = index
        this.isShow.dialogVisible3 = true
        this.reset=8
      },
      fenji(index){
        console.log(index)
        this.datas.windSpeedSettingBean.windSpeedEarlyWarning=index
      },
      fenji1(index){
        this.datas.windSpeedSettingBean.windSpeedWarning=index
      },
      sj(){
        function formatDateTime(date){
          var y = date.getFullYear()
          var m = date.getMonth() + 1
          m = m < 10 ? ('0' + m) : m
          var d = date.getDate()
          d = d < 10 ? ('0' + d) : d
          var h = date.getHours()
          var minute = date.getMinutes()
          var miao = date.getSeconds()
          minute = minute < 10 ? ('0' + minute) : minute
          return y + '-' + m + '-' + d+' '+h+':'+minute+':'+miao
        }
        let date = formatDateTime(new Date())
        return date
      },
      // 上传防碰撞
      uploadCollisionSettings(){
        let data1 = JSON.stringify(this.datas1)
        let sj = this.sj()
        let _this = this
        myHttp.uploadCollisionSettings({
          "imei": `${_this.$route.query.id}`,
          "settings": `${data1}`,
          "setDate": `${sj}`
        }).then(res=>{console.log(res,'10086');})
      },
      // 上传基础信息
      uploadTowerSettings(){
        let data1 = JSON.stringify(this.datas)
        let sj = this.sj()
        let _this = this
        myHttp.uploadTowerSettings({
          "imei": `${_this.$route.query.id}`,
          "settings": `${data1}`,
          "setDate": `${sj}`
        }).then(res=>{
          console.log(res,888)
        })
      },
      //获取防碰撞
      getCollision(){
        let _this = this
        myHttp.getCollisionSettings({
          "imei": `${_this.$route.query.id}`
        }).then(res=>{
          console.log(res,999)
          if(JSON.parse(res.data.data.settings).length!==0){
            _this.datas1 = JSON.parse(res.data.data.settings)
          }
          console.log(_this.datas1)
        })
      },
      // 获取配置
      getBasic(){
        let _this = this
        myHttp.getTowerSettings({
          "imei": `${_this.$route.query.id}`
        }).then(res=>{
          console.log(res,'999999999999999')
          console.log(JSON.parse(res.data.data.settings))
          // console.log(JSON.parse(res.data.data.settings))
          if(JSON.parse(res.data.data.settings).length!==0){
            _this.datas = JSON.parse(res.data.data.settings)
          }
          // _this.serverAddress=datas.deviceSettingBean.serverAddress
          // _this.mailingAddress=datas.deviceSettingBean.mailingAddress
          // _this.cameraType=datas.deviceSettingBean.cameraType
          // _this.openFace=datas.deviceSettingBean.openFace
          // _this.cardNumber=datas.deviceSettingBean.cardNumber
          // _this.hookVisualization=datas.deviceSettingBean.hookVisualization
        }).catch(res=>{
          console.log(res)
        })
      },
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      handleClose2(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      show(a){
        if(a===1){
          this.isShow.a = true
        }else if(a===2){
          this.isShow.b = true
        }
      },
      hide(){
        if(this.isShow.a===true||this.isShow.b===true){
          this.isShow.a = false
          this.isShow.b = false
        }
      }
    }
  }
</script>

<style scoped>
.main{
  background-color: #ECF0F5;
  height: 90.7vh;
  padding-left: 0.417vw;
  padding-right: 1.25vw;
}
.nav{
  display: flex;
  align-items: center;
  min-height: 4.525vh;
}
.scroll{
  height: 84.8vh;
  overflow: scroll;
}
.scroll::-webkit-scrollbar{
  width: 0;
  height: 0;
}
.cont{
  min-width: 1656px;
  background-color: #ffffff;
  padding: 1vh 0.729vw;
}
.box1{
  height: 19.385vh;
  box-shadow: 1.9px 2.3px 10px 0px 
		rgba(105, 159, 204, 0.5);
	border-radius: 6px;
  padding-top: 0.905vh;
}
.dian{
  width: 0.754vh;
	height: 0.754vh;
	background-color: #0b62f0;
  border-radius: 50%;
  margin-right: 0.417vw;
  margin-left: 0.729vw;
}
.title{
  display: flex;
  align-items: center;
  margin-bottom: 0.452vh;
}
.items{
  padding: 0 1.615vw;
}
.row{
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 1.961vh;
  margin-bottom: 2vh;
}
.item{
  display: flex;
  justify-content: space-between;
  width: 16.239vw;
}
.item>p{
  font-family: PingFang-SC-Bold;
	font-size: 14px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #333333;
}
.item>input{
  background-color: #f5f6fa;
	border-radius: 4px;
  width: 9.792vw;
  border: solid 0.5px #EAEAEA;
  padding-left: 10px;
  padding-top: 0.452vh;
  padding-bottom: 0.452vh;
  font-size: 12px;
}
.item>input:focus {
  box-shadow: 1.9px 2.3px 10px 0px 
		rgba(105, 159, 204, 0.5);
      outline: none; 
}
.item-xxx{
  position: relative;
}
.item-xxx::after{
content: "/min";
position: absolute;
right: 5px;bottom: 25%;
font-size: 12px;
}
.btn1{
  border: none;
  width: 3.13vw;
	height: 1.35vw;
	background-color: #3f9eff;
	border-radius: 0.21vw;
  color: #fff;
  font-size: 14px;
  margin-right: 40%;
}
.btn2{
  width: 3.13vw;
	height: 1.35vw;
	background-color: #fff;
	border-radius: 0.21vw;
  font-size: 14px;
  margin-right: 40%;
  border-radius: 4px;
	border: solid 1px #bbbbbb;
}
.btn3{
  border: none;
  width: 62px;
	height: 26px;
	background-color: #3f9eff;
	border-radius: 0.3vh;
  font-size: 14px;
  color: #fff;
}
.input-i{
  font-size: 12px;
  background-color: #f5f6fa;
	border-radius: 4px;
  border: solid 0.5px #EAEAEA;
  padding-left: 6px;
  padding-top: 0.452vh;
  padding-bottom: 0.452vh;
  width: 50%;
  margin-right: 3px;
}
.input-i:focus {
  box-shadow: 1.9px 2.3px 10px 0px 
		rgba(105, 159, 204, 0.5);
      outline: none; 
}
.item-r{
  display: flex;
  justify-content: end;
}
.box{
  min-width: 1649px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.box2, .box3, .box4, .box5, .box6, .box7, .box8, .box9, .box10{
  width: 544px;
	height: 298px;
  background-color: #ffffff;
	box-shadow: 1.9px 2.3px 10px 0px 
		rgba(105, 159, 204, 0.5);
	border-radius: 6px;
  margin-top: 1vh;
  padding: 14px 0px 9px 0px;
}
.text{
  margin-left: 2px;
  color: #666666;
}
.cont-i{
  height: 235px;
  position: relative;
}
.row-i{
  display: flex;
  justify-content: space-between;
  margin-left: 32px;
  margin-right: 14px;
}
.row-i>p{
  font-family: PingFang-SC-Bold;
	font-size: 14px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 30px;
	letter-spacing: 0px;
	color: #333333;
}
.row-i>.row-i-r>input{
  width: 188px;
  height: 26px;
  font-size: 12px;
  background-color: #f5f6fa;
	border-radius: 4px;
  border: solid 0.5px #EAEAEA;
  padding-left: 6px;
}
.row-i>.row-i-r>input:focus {
  box-shadow: 1.9px 2.3px 10px 0px 
		rgba(105, 159, 204, 0.5);
      outline: none; 
}
.row-i-r{
  width: 328px;
  display: flex;
  justify-content: space-between;
}
.blue{
  border: none;
  width: 60px;
	height: 26px;
	background-color: #3f9eff;
	border-radius: 4px;
  font-family: PingFang-SC-Medium;
	font-size: 14px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #fefefe;
  line-height: 26px;
}
.blue:hover, .btn1:hover, .btn3:hover{
  box-shadow: 0 0 8px 0 rgba(232, 237, 250, 60%),
  0 2px 4px 0 rgba(232, 237, 250, 50%);
  background-color: #7bbdff;
  cursor: pointer;
}
.btn2:hover, .btn-i:hover{
  cursor: pointer;
    color: #409eff;
    border-color: #c6e2ff;
    background-color: #ecf5ff;
}
.unit{
  font-family: PingFang-SC-Medium;
	font-size: 14px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 26px;
	letter-spacing: 0px;
	color: #333333;
  margin-right: 20px;
}
.btn-i{
  width: 60px;
	height: 26px;
	background-color: #fff;
	border-radius: 0.21vw;
  font-size: 14px;
  border-radius: 4px;
	border: solid 1px #bbbbbb;
  font-family: PingFang-SC-Medium;
	font-size: 14px;
	font-weight: normal;
	font-stretch: normal;
	line-height: 26px;
	letter-spacing: 0px;
	color: #333333;
}
.cont-i-b{
  position: absolute;
  left: 201px;
  bottom: -10px;
  width: 136px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.row-a{
  margin-bottom: 26px;
}
.row-aa{
  margin-bottom: 26px;
  padding-top: 36px;
}
.row-c{
  padding: 2px 0;
}
.menu-title{
  width: 188px;
  height: 26px;
  background-color: #f5f6fa;
  border-radius: 4px;
  border: solid 0.5px #EAEAEA;
  padding-left: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.menu-title>p{
  font-size: 12px;
  line-height: 26px;
  text-align: start;
  color:#858585;
}
.menu-title>i{
  margin-top:5px;
  margin-right: 20px;
  width: 0px;
    height: 0px;
    border: 6px solid transparent;
    border-top-color: #858585;
}
.row-dd{
  padding-top:45px ;
}
.row-d{
  padding-bottom:20px ;
}
.menu-content{
  position: absolute;
  left: 0;
  bottom: -251px;
  width: 188px;
	height: 255px;
  z-index: 20;
  background-color: #fff;
}
.m-c-t{
  background-color: #f9fafc;
  line-height: 30px;
  font-family: PingFang-SC-Medium;
	font-size: 14px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #333333;
  text-align: start;
  padding: 0 20px;
}
.m-c-t-b>p, .m-c-item>p{
  font-family: PingFang-SC-Medium;
	font-size: 12px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #333333;
  padding: 2.5px 20px;
}
.m-c-t-b, .m-c-item{
  display: flex;
  justify-content: space-between;
}
.m-c-item:hover{
  background-color: #eee;
}
.menu-content-b{
  height: 195px;
  bottom: -190px;
}
.row-aaa{
  padding: 88px 0;
}
.text-i{
  font-family: PingFang-SC-Medium;
	font-size: 14px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #333333;
}
.text-ii{
  width: 100px;
  display: flex;
  justify-content: space-between;
}
.text-ii>p{
  font-family: PingFang-SC-Medium;
	font-size: 14px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
	color: #666666;
}
.btnn{
  width: 110px;
}
.bb{
  width: 190px;
  left:114px;
}
.content-s{
  display: flex;
  width: 152px;
  justify-content: space-between;
}
.content-s>.item-s{
  font-family: PingFang-SC-Medium;
	font-size: 14px;
	font-weight: normal;
	font-stretch: normal;
	letter-spacing: 0px;
  line-height: 30px;
	color: #333333;
}
.jiaodu{
  width: 30px;
    height: 26px;
    font-size: 12px;
    background-color: #f5f6fa;
    border-radius: 4px;
    border: solid 0.5px #EAEAEA;
    padding-left: 6px
}

.jiaodu:focus{
  box-shadow: 1.9px 2.3px 10px 0px rgb(105 159 204 / 50%);
    outline: none;
}
::v-deep .el-dialog{
  margin-top: 30vh !important;
}
::v-deep .chongzhi>.el-dialog{
  width: 21% !important;
}
</style>